import Vue from 'vue'
import { URL_PRODUCT_SECTIONS } from '@/constants/urls'
import { PRODUCT_SECTION_MANAGEMENT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [PRODUCT_SECTION_MANAGEMENT.STATE.CURRENT]: null,
  [PRODUCT_SECTION_MANAGEMENT.STATE.PRODUCT_SECTIONS]: null
}

const actions = {
  async [PRODUCT_SECTION_MANAGEMENT.ACTIONS.GET_PRODUCT_SECTIONS] ({ dispatch, commit }, params) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_PRODUCT_SECTIONS}?${Vue.helpers.getQueryParamsString(params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(PRODUCT_SECTION_MANAGEMENT.MUTATIONS.GET_PRODUCT_SECTIONS, resp.data)
  },
  async [PRODUCT_SECTION_MANAGEMENT.ACTIONS.CLEAR_PRODUCT_SECTIONS] ({ commit }) {
    commit(PRODUCT_SECTION_MANAGEMENT.MUTATIONS.CLEAR_PRODUCT_SECTIONS)
  },
  async [PRODUCT_SECTION_MANAGEMENT.ACTIONS.GET_PRODUCT_SECTION_INFO] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_PRODUCT_SECTIONS}/${model.id}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(PRODUCT_SECTION_MANAGEMENT.MUTATIONS.GET_PRODUCT_SECTION_INFO, resp.data)
  },
  async [PRODUCT_SECTION_MANAGEMENT.ACTIONS.EDIT_PRODUCT_SECTION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_PRODUCT_SECTIONS}/${model.id}`,
      model: model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [PRODUCT_SECTION_MANAGEMENT.ACTIONS.DELETE_PRODUCT_SECTION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getAdminHost()}${URL_PRODUCT_SECTIONS}/${model.id}`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.DELETE_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [PRODUCT_SECTION_MANAGEMENT.ACTIONS.ADD_PRODUCT_SECTION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_PRODUCT_SECTIONS}`,
      model: model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [PRODUCT_SECTION_MANAGEMENT.ACTIONS.EDIT_ORGANIZATIONS_BY_PRODUCT_SECTION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_PRODUCT_SECTIONS}/${model.id}/organizations`,
      model: model.organizations
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [PRODUCT_SECTION_MANAGEMENT.ACTIONS.CLEAR_PRODUCT_SECTION_INFO] ({ commit }) {
    commit(PRODUCT_SECTION_MANAGEMENT.MUTATIONS.CLEAR_PRODUCT_SECTION_INFO)
  }
}

const mutations = {
  [PRODUCT_SECTION_MANAGEMENT.MUTATIONS.GET_PRODUCT_SECTIONS] (state, model) {
    state[PRODUCT_SECTION_MANAGEMENT.STATE.PRODUCT_SECTIONS] = model
  },
  [PRODUCT_SECTION_MANAGEMENT.MUTATIONS.CLEAR_PRODUCT_SECTIONS] (state) {
    state[PRODUCT_SECTION_MANAGEMENT.STATE.PRODUCT_SECTIONS] = null
  },
  [PRODUCT_SECTION_MANAGEMENT.MUTATIONS.GET_PRODUCT_SECTION_INFO] (state, model) {
    state[PRODUCT_SECTION_MANAGEMENT.STATE.CURRENT] = model
  },
  [PRODUCT_SECTION_MANAGEMENT.MUTATIONS.CLEAR_PRODUCT_SECTION_INFO] (state) {
    state[PRODUCT_SECTION_MANAGEMENT.STATE.CURRENT] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
